import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CustomPieChart from "../CustomPieChart";
import TestScenarioDetail from "../TestScenarioDetail";
import HorizontalStackedBarChart from "../HorizontalBarChart";
import ScenarioVariationDetails from "../ScenarioVariationDetails";
import ScenarioOverview from "../ScenarioOverview";
import { Typography, IconButton, Tooltip, Fab } from "@material-ui/core";
import ExecutionReportOverview from "../ExecutionReportOverview";
import axios from "axios";
import { withRouter } from "react-router-dom";
import CustomGaugeChart from "../CustomGaugeChart";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { KeyboardArrowUp } from "@material-ui/icons";
import "./scrollToTopButton.css";

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
    },
  },
};

const customStylesActivation = {
  ...customStyles,
  rows: {
    style: {
      minHeight: "72px",
      cursor: "",
      fontSize: 16,
    },
  },
};

const ExecutionDetails = ({ selectedExecution, onBack, location }) => {
  const [loading, setLoading] = useState(false);
  const [selectedTestScenario, setSelectedTestScenario] = useState(null);
  const [selectedScenario, setSelectedScenario] = useState(null);
  const [selectedScenarioForDetailedView, setSelectedScenarioForDetailedView] =
    useState([]);
  const [overallDetails, setOverallDetails] = useState({});
  const [scenarioOverviewDetails, setScenarioOverviewDetails] = useState([]);
  const [scrollingFilter, setScrollingFilter] = useState("Total");
  const [isVisible, setIsVisible] = useState(false);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setIsVisible(window.scrollY > 300);
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  console.log("FETCH DATA", "==========================");
  const query = new URLSearchParams(location.search);
  const execution_id = query.get("execution_id");
  const reporting_level = query.get("reporting_level");
  const scenario_group_name = query.get("scenario_group_name");
  const page = query.get("page");
  const isReportingMode = query.get("mode") === 'reporting';
  console.log("PAGE RECRIVED", page)

  const scrollToTop = () => {
    console.log("reportingPageTop");
    // window.scrollTo(0,0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const section = document.getElementById("reportingPageTop");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const isFctw = !!(overallDetails && overallDetails.fctw);
  // const isFctw = !!(overallDetails && ((!!overallDetails.fctw && overallDetails.fctw !== "false" )|| overallDetails.fctw === "true")) ;

  const handleScrollingFilter = (value) => {
    setScrollingFilter(value);
  }

  const handleReportDownload = async () => {
    const fileToDownload = await axios.post(
      "/generate-presigned-url",
      {
        s3_location: overallDetails.summary_xlsx_report,
      }
    );
    window.open(fileToDownload.data.presigned_url);
  }

  const fetchData = async () => {
    setLoading(true);
    let body = {
      execution_id: execution_id,
      reporting_level: reporting_level,
      scenario_group_name:scenario_group_name
    };
    if (reporting_level === "test_run_id") {
      const test_run_id = query.get("test_run_id");

      body = {
        ...body,
        test_run_id: test_run_id,
      };
    }
    try {
      let response;

      if (page === "closed_loop") {
        response = await axios.post(
          `/cm/reporting/fetch-overall-details-for-test-run`,
          body
        );
      } else {
        if (isReportingMode) {
          response = await axios.post('/cm/reporting-mode/reporting/fetch-overall-details-for-test-run',
            {cad_topology_job_uuid: execution_id}
          )
        } else {
          response = await axios.post(
            `/cm/open_loop_pg/reporting/fetch-overall-details-for-test-run`,
            body
          );
        }
      }

      console.log("OVERALL DETAILS", response.data);
      setOverallDetails(response.data);


      let responseScenarioDetails;
      if (page === "closed_loop") {
        responseScenarioDetails = await axios.post(
          `/cm/reporting/fetch-scenario-details`,
          body
        );
      } else {
        if (isReportingMode) {
          responseScenarioDetails = await axios.post(
            'cm/reporting-mode/reporting/fetch-scenario-details',
            {cad_topology_job_uuid: execution_id}
          );
        } else {
          responseScenarioDetails = await axios.post(
            `/cm/open_loop_pg/reporting/fetch-scenario-details`,
            body
          );
        }
      }



      // const responseScenarioDetails = await axios.post(
      //   "/cm/reporting/fetch-scenario-details",
      //   body
      // );
      console.log("SCENARIO DETAILS", responseScenarioDetails.data);
      setScenarioOverviewDetails(responseScenarioDetails.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRowClick = (row) => {
    setSelectedTestScenario(row);
  };

  const handleClickForVariation = (variations) => {
    console.log("SETTING VARIATIONS ON CLICK", typeof variations);
    // setSelectedScenarioForDetailedView(variations.replace(/NaN/g, 'null'));
    setSelectedScenarioForDetailedView(variations);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (selectedTestScenario) {
    return (
      <TestScenarioDetail
        testScenario={selectedTestScenario}
        onBack={() => setSelectedTestScenario(null)}
      />
    );
  }

  if (selectedScenarioForDetailedView.length > 0) {
    return (
      <ScenarioVariationDetails
        selectedScenarioForDetailedView={selectedScenarioForDetailedView}
        selectedScenario={selectedScenario}
        page={page}
        isFctw={isFctw}
        // onBack={() => setSelectedScenarioForDetailedView(null)}
        onBack={() => setSelectedScenarioForDetailedView([])}
      />
    );
  }

  return (
    <>
      {overallDetails && overallDetails.summary_xlsx_report_flag ? <div
        style={{
          backgroundColor: "rgba(255,255,255,0.5)",
          borderRadius: 10,
          padding: "20px",
        }}
        id="reportingPageTop"
      >
        <Grid
          container
          spacing={3}
          style={{
            fontWeight: 400,
            fontSize: "16px",
            backgroundColor: "white",
            border: "solid 1px rgba(0,0,0,.2)",
            borderRadius: "10px",
            padding: "10px",
            margin: "0px",
            width: '100%'
          }}
        >
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <h3>Execution Details</h3>
            {overallDetails.summary_xlsx_report_flag === true && !isFctw &&
              <Tooltip placement="top" title={<h6>Download Summary Report</h6>}>
                <IconButton
                  aria-label="download"
                  onClick={handleReportDownload}
                >
                  <CloudDownloadIcon />
                </IconButton>
              </Tooltip>}
          </div>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item xs={2}>
              Model
            </Grid>
            <Grid item xs={3}>
              {overallDetails.model}
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={2}>
              Subject Under Test
            </Grid>
            <Grid item xs={3}>
              {overallDetails.execution}
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={2}>
              Executed By
            </Grid>
            <Grid item xs={3}>
              {overallDetails.executed_by}
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={2}>
              Timestamp
            </Grid>
            <Grid item xs={3}>
              {overallDetails.startedat}
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          style={{
            margin: "30px 0 0 0",
            backgroundColor: "white",
            padding: "1%",
            border: "solid 1px rgba(0,0,0,.2)",
            borderRadius: "10px",
            width: '100%'
          }}
          spacing={3}
        >
          <Grid item xs={isFctw? 10: 8}>
            {overallDetails && (
              <ExecutionReportOverview
                selectedExecution={overallDetails}
                handleScrollingFilter={handleScrollingFilter}
                onBack={() => setSelectedScenarioForDetailedView([])}
                isFctw={isFctw}
              />
            )}
          </Grid>

          <Grid item xs={2}>
            <Box
              sx={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "100%",
              }}
            >
              <Box sx={{ marginBottom: "16px" }}>
                {overallDetails.mandatory_target && (
                  <CustomGaugeChart
                    percentagePassed={
                      overallDetails.mandatory_target.pass_percentage
                    }
                  />
                )}
              </Box>
              <Typography variant="h6">Mandatory Target</Typography>
            </Box>
          </Grid>
          {!isFctw && <Grid item xs={2}>
            <Box
              sx={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "100%",
              }}
            >
              <Box sx={{ marginBottom: "16px" }}>
                {overallDetails.development_target && (
                  <CustomGaugeChart
                    percentagePassed={
                      overallDetails.development_target.pass_percentage
                    }
                  />
                )}
              </Box>
              <Typography variant="h6">Development Target</Typography>
            </Box>
          </Grid>}
        </Grid>
        <Grid
          container
          style={{
            margin: "30px 0 0 0",
            backgroundColor: "white",
            padding: "1%",
            border: "solid 1px rgba(0,0,0,.2)",
            borderRadius: "10px",
            width: '100%'
          }}
          spacing={3}
        >
          <Grid item xs={4}>
            <Box
              sx={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "100%",
              }}
            >
              <Box sx={{ marginBottom: "16px", width: "100%" }}>
                {overallDetails.scenario_type && (
                  <div style={{ height: "350px", width: "100%" }}>
                    <CustomPieChart
                      dataPassed={overallDetails.scenario_type}
                      keyPassed={"count"}
                      colorKey={"name"}
                    />
                  </div>
                )}
              </Box>
              <Typography variant="h6">Scenario Type</Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box
              sx={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "100%",
              }}
            >
              <Box sx={{ marginBottom: "16px", width: "100%" }}>
                {overallDetails.target_class && (
                  <div style={{ height: "350px", width: "100%" }}>
                    <CustomPieChart
                      dataPassed={overallDetails.target_class}
                      keyPassed={"count"}
                      colorKey={"name"}
                    />
                  </div>
                )}
              </Box>
              <Typography variant="h6">Target Class</Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box
              sx={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "100%",
              }}
            >
              <Box sx={{ marginBottom: "16px", width: "100%" }}>
                {overallDetails.assessment_code && (
                  <div style={{ height: "350px", width: "100%" }}>
                    <CustomPieChart
                      dataPassed={overallDetails.assessment_code}
                      keyPassed={"count"}
                      colorKey={"name"}
                    />
                  </div>
                )}
              </Box>
              <Typography variant="h6">Assessment Code</Typography>
            </Box>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={3}
          style={{
            margin: "30px 0 0 0",
            backgroundColor: "white",
            padding: "1%",
            border: "solid 1px rgba(0,0,0,.2)",
            borderRadius: "10px",
            width: '100%'
            // height: "500px",
            // overflowY: "auto",
          }}
        >
          <Grid item 
            xs={10}
            id="scenario-details-table-scroll"
          >
            <ScenarioOverview
              scrollingFilter={scrollingFilter}
              // onRowClicked={handleRowClickVariation}
              scenarioOverviewDetails={scenarioOverviewDetails}
              handleClickForVariation={handleClickForVariation}
              page={page}
              isFctw={isFctw}
            />
          </Grid>
        </Grid>
      </div> : <><h1>Report Data not Found</h1></>
      }
      <div style={{ display:"flex", justifyContent: "flex-end",marginTop: "-70px" ,marginRight: "10px"}}>
        <Fab
          color="primary"
          aria-label="scroll to top"
          className={`scroll-to-top ${isVisible ? "visible" : ""}`}
          onClick={scrollToTop}
        >
          <KeyboardArrowUp />
        </Fab>
      </div>
      
    </>
  );
};

export default withRouter(ExecutionDetails);
